{
	"noData": {
		"title": "No encontramos lo que buscas",
		"description": "Intenta seleccionar una nueva ubicación o período, o inténtalo de nuevo más tarde."
	},
	"noFilters": {
		"title": "Todavía no hay nada por aquí",
		"description": "Selecciona la ubicación de búsqueda o verifica nuevamente más tarde."
	},
	"noContent": {
		"title": "Aún no hay nada por aquí",
		"description": "Seleccione un período para comenzar a explorar los datos."
	}
}
